jQuery(document).ready(function ($) {
  //############################################//
  //###*****   Module - People
  //############################################//

  // Get height in a row of people modules using a master class
  // .set-people-height
  const mq = window.matchMedia('(min-width: 768px)');

  if (mq.matches) {
    if ($('.set-people-height')) {
      var maxHeight = 0;
      $('.set-people-height').each(function () {
        var tthis = $(this);
        console.log(tthis);
        $(this)
          .find('.c-person--module.c-person--col .c-person__content')
          .each(function () {
            var thisH = $(this).height();
            if (thisH > maxHeight) {
              maxHeight = thisH;
            }
          });
        $(this)
          .find('.c-person--module.c-person--col .c-person__content')
          .height(maxHeight)
          .addClass('bomp');
      });
    }
  }
});
